import { jsx as _jsx } from "react/jsx-runtime";
import { AccountEmpty } from '../account-empty';
import { useMemo } from 'react';
export default function ComponentWeb({ onPressCta, }) {
    const props = useMemo(() => {
        return {
            callout: {
                title: 'Funds',
                message: 'XBTO offers a comprehensive suite of investment services designed to help investors accumulate coins, preserve capital, and capture alpha.',
                ctas: [
                    {
                        variant: 'secondary',
                        label: 'Explore our funds',
                        onPress: onPressCta,
                        size: 'base',
                        style: { width: 'auto' },
                    },
                ],
            },
            imageUri: {
                XS: 'product-splash/funds/Base@3x.png',
                S: 'product-splash/funds/LG@2x.png',
                M: 'product-splash/funds/LG@3x.png',
                L: 'product-splash/funds/XL@2x.png',
                XL: 'product-splash/funds/XL@3x.png',
            },
            cards: [
                {
                    icon: 'AutoGraph',
                    label: 'Coin accumulation',
                    description: 'Increase your digital asset holdings and preserve your wealth.',
                },
                {
                    icon: 'Troubleshoot',
                    label: 'Absolute return',
                    description: 'Capture alpha in cryptocurrency markets with active management.',
                },
                {
                    icon: 'Cases',
                    label: 'Custom portfolios',
                    description: 'We offer diverse investment structures, including active funds, separate account mandates, and custom portfolios, tailored to your specific needs.',
                },
            ],
        };
    }, [onPressCta]);
    return _jsx(AccountEmpty, Object.assign({}, props));
}
